import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c757d8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-controls"]
const _hoisted_2 = { class: "row justify-content-between" }
const _hoisted_3 = { class: "col-md" }
const _hoisted_4 = { class: "dokumentnavn" }
const _hoisted_5 = { class: "col-md" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-small"
}
const _hoisted_7 = {
  key: 1,
  class: "badge badge-small"
}
const _hoisted_8 = {
  key: 2,
  class: "badge badge-small"
}
const _hoisted_9 = {
  key: 3,
  class: "badge badge-small"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "action-div"
}
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#grade" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "action-div"
}
const _hoisted_23 = ["id"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "action-div"
}
const _hoisted_27 = ["id"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "action-div"
}
const _hoisted_31 = ["data-micromodal-trigger", "id"]
const _hoisted_32 = ["id"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#send" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 4,
  class: "action-div"
}
const _hoisted_36 = ["id"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#format-list-checks" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 5,
  class: "action-div"
}
const _hoisted_40 = ["id"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "action-div" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_45 = {
  key: 6,
  class: "action-div"
}
const _hoisted_46 = ["id"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 7,
  class: "action-div"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#delete" })
], -1))
const _hoisted_51 = { class: "accordion accordion-unbordered accordion-multiselectable col-8" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "tg-listing"
}
const _hoisted_54 = ["aria-controls"]
const _hoisted_55 = ["id"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_57 = { class: "about-text-box" }
const _hoisted_58 = {
  key: 1,
  class: "tg-listing"
}
const _hoisted_59 = { class: "tg-none-box mt-0" }
const _hoisted_60 = { class: "tg-none-inner" }
const _hoisted_61 = ["aria-controls"]
const _hoisted_62 = ["id"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_64 = { class: "about-text-box" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "about-text-label" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "about-text-label" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "about-text-label" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "about-text-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InviterTilbudsgiver = _resolveComponent("InviterTilbudsgiver")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("button", {
      class: "accordion-button",
      "aria-expanded": "false",
      "aria-controls": this.label()
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(this.dokument.tender_name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.dokument.display_ended)
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.frist-overskredet' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.display_published)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.publiceret' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.display_open && !_ctx.dokument.orderHasBeenEdited)
            ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.aaben-for-tilbud' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.isNotOriginalOG || _ctx.dokument.orderHasBeenEdited)
            ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.ordre-er-redigeret' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.tco-linie.produktgruppe.navn' }, null, 8, ["tekstNoegle"]),
          _createTextVNode(" " + _toDisplayString(this.dokument.product_group_name), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.startdato.navn' }, null, 8, ["tekstNoegle"]),
          _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.start_date)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.tilbudsfrist.navn' }, null, 8, ["tekstNoegle"]),
          _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.end_date)), 1)
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: this.label(),
      "aria-hidden": "true",
      class: "accordion-content"
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "actions col-3",
          style: _normalizeStyle(this.getActionsBoxHeight(_ctx.dokument.status))
        }, [
          _createElementVNode("h5", null, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.handlinger' }, null, 8, ["tekstNoegle"])
          ]),
          _hoisted_17,
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED || _ctx.dokument.status === _ctx.DocumentStatus.CLOSED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: '/evalueringOG/' + _ctx.dokument.id,
                  class: "function-link"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "icon-svg",
                      id: 'svg-Tilbud-'+_ctx.dokument.id,
                      focusable: "false",
                      "aria-hidden": "true"
                    }, _hoisted_21, 8, _hoisted_19)),
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.se-evaluering-af-tilbud' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_router_link, {
                  to: '/blanket/' + _ctx.dokument.id,
                  class: "function-link"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "icon-svg",
                      id: 'svg-Rediger-'+_ctx.dokument.id,
                      focusable: "false",
                      "aria-hidden": "true"
                    }, _hoisted_25, 8, _hoisted_23)),
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.rediger-indkoeb' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.DRAFT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: '/blanket/' + _ctx.dokument.id,
                  class: "function-link"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "icon-svg",
                      id: 'svg-RedigerKladde-'+_ctx.dokument.id,
                      focusable: "false",
                      "aria-hidden": "true"
                    }, _hoisted_29, 8, _hoisted_27)),
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.rediger-kladde' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED && _ctx.IsNotOverdue(_ctx.dokument.end_date))
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "function-link",
                  "data-micromodal-trigger": 'invite-'+_ctx.dokument.id,
                  id: 'invite-og-'+_ctx.dokument.id
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: "icon-svg",
                    id: 'svg-Inviter-'+_ctx.dokument.id,
                    focusable: "false",
                    "aria-hidden": "true"
                  }, _hoisted_34, 8, _hoisted_32)),
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.inviter-tilbudsgiver' }, null, 8, ["tekstNoegle"])
                ], 8, _hoisted_31),
                _createVNode(_component_InviterTilbudsgiver, {
                  ogId: _ctx.dokument.id,
                  modalId: 'invite-'+_ctx.dokument.id
                }, null, 8, ["ogId", "modalId"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED && _ctx.IsNotOverdue(_ctx.dokument.end_date))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_router_link, {
                  to: { path: '/blanketTG', query: { og_id: _ctx.dokument.id , product_id: _ctx.dokument.nature_code}},
                  class: "function-link"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "icon-svg",
                      id: 'svg-udfyld-'+_ctx.dokument.id,
                      focusable: "false",
                      "aria-hidden": "true"
                    }, _hoisted_38, 8, _hoisted_36)),
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.udfyld-tilbudsoplysninger' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED || _ctx.dokument.status === _ctx.DocumentStatus.CLOSED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: '/blanket/opsummering/' + _ctx.dokument.id,
                  class: "function-link"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "icon-svg",
                      id: 'svg-Opsummering-'+_ctx.dokument.id,
                      focusable: "false",
                      "aria-hidden": "true"
                    }, _hoisted_42, 8, _hoisted_40)),
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.se-opsummering-af-indkoeb' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printOpsummering(_ctx.dokument.id))),
              class: "function-link"
            }, [
              _hoisted_44,
              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.og-blanket.dokumentvisning.handlinger.download-opsummering" })
            ])
          ]),
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "function-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (this.closeTender(_ctx.dokument.id)))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: "icon-svg",
                    id: 'svg-Afslut-'+_ctx.dokument.id,
                    focusable: "false",
                    "aria-hidden": "true"
                  }, _hoisted_48, 8, _hoisted_46)),
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.afslut-indkoeb' }, null, 8, ["tekstNoegle"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dokument.status === _ctx.DocumentStatus.DRAFT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "function-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (this.deleteDraft(_ctx.dokument.id)))
                }, [
                  _hoisted_50,
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.handlinger.slet-kladde' }, null, 8, ["tekstNoegle"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("ul", _hoisted_51, [
          (_ctx.dokument.status === _ctx.DocumentStatus.PUBLISHED || _ctx.dokument.status === _ctx.DocumentStatus.CLOSED)
            ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                (_ctx.dokument.offercompanyNames.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("button", {
                        class: "accordion-button tg-accordion mt-0",
                        "aria-expanded": "false",
                        "aria-controls": this.label() + '-tg'
                      }, [
                        _createElementVNode("h5", null, [
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.knap.tilbudsgivere' }, null, 8, ["tekstNoegle"]),
                          _createTextVNode(" (" + _toDisplayString(_ctx.dokument.offercompanyNames.length) + ")", 1)
                        ])
                      ], 8, _hoisted_54),
                      _createElementVNode("div", {
                        id: this.label() + '-tg',
                        "aria-hidden": "true",
                        class: "accordion-content tg-accordion"
                      }, [
                        _hoisted_56,
                        _createElementVNode("div", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.dokument.offercompanyNames, (offerCompanyName) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row",
                              key: offerCompanyName
                            }, _toDisplayString(offerCompanyName), 1))
                          }), 128))
                        ])
                      ], 8, _hoisted_55)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("h5", null, [
                            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.knap.tilbudsgivere' }, null, 8, ["tekstNoegle"]),
                            _createTextVNode(" (" + _toDisplayString(_ctx.dokument.offercompanyNames.length) + ")", 1)
                          ])
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "accordion-button about-accordion",
              "aria-expanded": "true",
              "aria-controls": this.label() + '-about'
            }, [
              _createElementVNode("h5", null, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.knap.om-indkoebet' }, null, 8, ["tekstNoegle"])
              ])
            ], 8, _hoisted_61),
            _createElementVNode("div", {
              id: this.label() + '-about',
              "aria-hidden": "true",
              class: "accordion-content about-accordion"
            }, [
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.dokumentvisning.beskrivelse-af-indkoeb' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.tender_description), 1)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.udbudsnummer.navn' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.tender_number), 1)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.tco-linie.produktgruppe.navn' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.product_group_name), 1)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.tco-linie.antal-produkter.navn' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.tender_quantity), 1)
                ])
              ])
            ], 8, _hoisted_62)
          ])
        ])
      ])
    ], 8, _hoisted_15)
  ]))
}